import React from 'react'
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload';
const ParentPortal = () => {
  return (
    <>
    <div className="erp_links"> 
        <Link to="https://entab.online/SHSBUP" target="_blank">
          <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Campulogo.png" className="img-fluid"  alt="Sacred Heart School Balia"/></LazyLoad>
          </Link> 
    </div>
    </>
  )
}

export default ParentPortal
